import $ from "jquery";
import baseClass from "./base/base";

window.$ = $;
window.jQuery = $;
window.CKEDITOR_BASEPATH = "/ckeditor/libs/";

baseClass.OnLoadArrAdd(function () {
  setInterval(() => {
    const now = Date.now();
    for (const [url, entry] of Object.entries(window.__preloadedPages || {})) {
      if (!entry || now - entry.timestamp > entry.maxAge) {
        console.log("Interval delete: ", url);
        delete window.__preloadedPages[url];
      }
    }
  }, 60000);
});
